export default "__VITE_ASSET__DBIjlznG__"